import { useState, useContext, useEffect, useRef } from 'react'
import { signInWithEmailAndPassword, getAuth, onAuthStateChanged } from 'firebase/auth'
import { Link, useNavigate } from 'react-router-dom'
import LoadingContext from '../contexts/loading/LoadingContext'
import LogoImg from '../images/logo.png'
import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  Button,
  InputRightElement,
  useToast,
  Box,
  Text,
  Center
} from '@chakra-ui/react'
import OAuth from '../components/OAuthGoogle/OAuth'
import { Helmet } from 'react-helmet'
import { Alert } from '@chakra-ui/react'

export default function SignIn() {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const { email, password } = formData
  const { buttonLoading, dispatch } = useContext(LoadingContext)

  const navigate= useNavigate()
  const toast = useToast()
  const auth = getAuth()
  const isMounted = useRef(true)

  useEffect(() => {
    if (isMounted) {
        onAuthStateChanged(auth, (user) => {
            if (user) {
              navigate('/')
            }
        })
    }

    return () => {
        isMounted.current = false
    }

  }, [isMounted])

  const changeHandler = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }))
  }
  
  const submitHandler = async () => {
    setLoading(true);

    try {
      const userCredentials = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredentials.user;

      if (user) {
        setLoading(false);
        Alert.alert('Login Successful', `Hello ${user.displayName || 'User'}`);
        navigate('Home'); // Redirect to Home screen
      }
    } catch (error) {
      setLoading(false);
      console.log(error.code);

      switch (error.code) {
        case 'auth/network-request-failed':
          Alert.alert('Error!', 'Network error! Check your internet connection.');
          break;
        case 'auth/wrong-password':
          Alert.alert('Wrong Credentials', 'Incorrect email or password!');
          break;
        default:
          Alert.alert('Error!', 'Something went wrong. Please try again later.');
      }
    }
  };


  return (
    <>
        <Helmet>
        <title>
          SignIn | EstateGhar
        </title>
        <meta
          name="description"
          content={`SignIn to EstateGhar and find the best deals for your dream home! Explore our wide range of properties, connect with trusted agents, and make your real estate journey seamless and successful. SignIn now to access exclusive listings and personalized recommendations!`}
        />
          <link rel="canonical" href="https://estateghar.com/sign-in" />
      </Helmet>
      <div className='min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8'>
        <div className='max-w-md w-full space-y-8'>

              <div>
                <img
                  className="mx-auto h-12 w-auto"
                  src={LogoImg}
                  alt="Workflow"
                />
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Sign in</h2>
              </div>

              <form className='mt-8 space-y-6' onSubmit={submitHandler}>

                <FormControl>
                  <FormLabel htmlFor='email'>Email Address</FormLabel>
                  <Input placeholder='Enter your email'onChange={changeHandler} value={email} id='email' type='email' placeholer='Email' />
                </FormControl>

                <FormControl>
                  <FormLabel htmlFor='password'>Password</FormLabel>
                  <InputGroup size='md'>
                    <Input
                      value={password}
                      onChange={changeHandler}
                      id='password'
                      pr='4.5rem'
                      type={showPassword ? 'text' : 'password'}
                      placeholder='Enter password'
                    />
                    <InputRightElement width='4.5rem'>
                      <Button h='1.75rem' size='sm' onClick={() => setShowPassword(prev => !prev)}>
                        {showPassword ? 'Hide' : 'Show'}
                      </Button>
                    </InputRightElement>
                  </InputGroup>
                </FormControl>
              
                <div className="flex items-center justify-between">
                  <div className="text-sm">
                    <Link to='/sign-up' className="font-medium text-indigo-600 hover:text-indigo-500">
                      Dont have an account?
                    </Link>
                  </div>

                  <div className="text-sm">
                    <Link to='/forgot-password' className="font-medium text-indigo-600 hover:text-indigo-500">
                      Forgot my password
                    </Link>
                  </div>
                </div>
                
                <Button
                  className='mt-2'
                  type='submit' 
                  isLoading={buttonLoading} 
                  loadingText='Signing in' 
                  colorScheme='teal'>
                    Sign In
                </Button>
               
              </form>
             <OAuth />
        </div>
      </div>
    </>
  )
}
